import { Base } from './Base';
import Typography from '../interfaces/Typography';
import Colors from '../interfaces/Colors';
import Framing from '../interfaces/Framing';

export default class BranchDesktopBase {

    private static readonly colorPalette = new Base().getColorsPalette;

    static setShareStyles (base: Base): Base {
        base.colors = this.setColors(base.colors);
        base.framing = this.setFraming(base.framing);
        base.typography = this.setTypography(base.typography);

        return base;
    };

    private static setColors (colors: Colors): Colors {

        return colors;
    };

    private static setFraming (framing: Framing): Framing {

        return framing;
    };

    private static setTypography (typography: Typography): Typography {

        return typography;
    };
}


// WEBPACK FOOTER //
// webpack://frontendThemeProvider/src/themes/BranchDesktopBase.ts